import React from 'react'

import Header from "../componets/Header";
import Footer from "../componets/Footer";

import Events from '../componets/event-listing/Offer';

const EventListing = () => {
    return (
        <>
            <div className='bs-service-page'>
                <Header />
                <Events />
                <Footer />
            </div>
        </>
    )
}

export default EventListing